import React from 'react';
import styled from 'styled-components';
import { colorRed, colorMediumGray } from '../../config/theme';
import { StyledNativeInput } from './StyledNativeInput';

type TextInputProps = {
    label: string;
    placeholder?: string;
    name: string;
    required?: boolean;
    invalid?: boolean;
    type?: string;
    value: string;
    onChange: (name: string, val: string) => void;
    onBlur?: () => void;
}

const InputContainer = styled.label<{invalid?: boolean}>`
    ${(props) => props.invalid ? `color: ${colorRed};` : ''}

    > input {
        ${(props) => props.invalid ? `border: 2px solid ${colorRed}` : `border: 1px solid ${colorMediumGray}`};
        color: ${colorMediumGray};
        margin-bottom: 30px;
        max-width: 90%;
        @media screen and (min-width: 768px) {
            max-width: 135px;
        }
    }
`;

export function TextInput(props: TextInputProps) {
    return <InputContainer invalid={props.invalid}>
        <span className="label"><strong>{props.label}{props.required ? '*' : ''}</strong></span>
        <StyledNativeInput
            placeholder={props.placeholder || props.label}
            name={props.name}
            required={props.required}
            invalid={props.invalid}
            type={props.type}
            value={props.value}
            onChange={(e) => props.onChange(props.name, e.target.value)}
            onBlur={() => props.onBlur && props.onBlur()}
        />
    </InputContainer>;
}
